import { Controller, useWatch } from "react-hook-form";
import { PasswordFieldInput } from "modules/record/shared/fields/PasswordFieldInput";
import { encryptedValueFieldName } from "modules/record/shared/services/passwordField";
import { FieldProps } from "modules/record/record-producer/types/record-producer-types";
import { getFieldHelperText } from "../../services/fieldHelperText";
import { getRequiredFieldMessage } from "../../services/recordProducerValidation";
import { BaseField } from "./BaseField";

const isBlank = (value: unknown) => value === null || value === undefined || value === "";

export const PasswordFieldComponent = ({ column, control, baseFieldProps, runtimeProps }: FieldProps) => {
    const encryptedValue = useWatch({
        control,
        name: encryptedValueFieldName(column.name),
    });
    const isRequired = runtimeProps?.required ?? column.is_mandatory;

    return (
        <BaseField column={column} required={runtimeProps?.required} hidden={runtimeProps?.hidden} {...baseFieldProps}>
            <Controller
                name={column.name}
                control={control}
                defaultValue={column.default_value || ""}
                rules={{
                    validate: (value) => {
                        if (!isRequired || !isBlank(value) || !isBlank(encryptedValue)) {
                            return true;
                        }

                        return getRequiredFieldMessage(column);
                    },
                }}
                render={({ field, fieldState }) => (
                    <PasswordFieldInput
                        value={field.value ?? ""}
                        onChange={field.onChange}
                        disabled={runtimeProps?.readonly}
                        masked={isBlank(field.value) && !isBlank(encryptedValue)}
                        error={!!fieldState.error}
                        helperText={getFieldHelperText(fieldState, runtimeProps)}
                    />
                )}
            />
        </BaseField>
    );
};
